import React from "react";
import { Badge, DataTable, Spinner, TextStyle } from "@shopify/polaris";

const STATUS_BADGE = {
  completed:  "success",
  processing: "attention",
  failed:     "critical",
  pending:    "new",
};

function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-CA", {
    month:  "short",
    day:    "numeric",
    year:   "numeric",
    hour:   "2-digit",
    minute: "2-digit",
  });
}

export default function SyncHistoryTable({ syncs, loading }) {
  if (loading) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <Spinner size="small" />
      </div>
    );
  }

  if (!syncs || syncs.length === 0) {
    return <TextStyle variation="subdued">No syncs have run yet.</TextStyle>;
  }

  const rows = syncs.map((s) => [
    formatDate(s.created_at),
    s.triggered_by || "—",
    <Badge status={STATUS_BADGE[s.status]}>{s.status}</Badge>,
    s.duration_formatted || "—",
    s.total_scraped,
    s.total_inserted,
    s.total_updated,
    s.total_errors > 0
      ? <TextStyle variation="negative">{s.total_errors}</TextStyle>
      : "0",
  ]);

  return (
    <DataTable
      columnContentTypes={["text", "text", "text", "text", "numeric", "numeric", "numeric", "numeric"]}
      headings={["Triggered", "By", "Status", "Duration", "Scraped", "New", "Updated", "Errors"]}
      rows={rows}
    />
  );
}
